import { Component } from '@angular/core';
import { HomeBaseComponent } from '../home-base.component';

@Component({
  selector: 'app-home',
  templateUrl: './home-mobile.component.html',
  styleUrls: ['./home-mobile.component.scss'],
})
export class HomeMobileComponent extends HomeBaseComponent {}
